import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { endpointStub } from '../../../../../mocks/utils';
import queryString from 'query-string'

const queryBuilder = (endpoint: string, step: any): string => {


	// const stringifiedQuery = queryString.stringify(cleanedFilters, { arrayFormat: 'comma' });
	const stringifiedQuery = ''
	const builtQuery = endpoint + '?' + stringifiedQuery
	return builtQuery
}

export const validateStepApi = createApi({
	reducerPath: 'validateStepApi',
	baseQuery: fetchBaseQuery({ baseUrl: endpointStub }),
	endpoints: (builder) => ({
		// getPartnerProfile: builder.query({
		// 	query: ({ value, endpoint }) => endpoint + '?id=' + value
		// }),
		validateStep: builder.query({
			query: ({ step, endpoint }) => queryBuilder(endpoint, step)
		}),
	}),
})

// Hooks are auto-generated based on the defined endpoints
// export const { useGetPartnersQuery, useGetLocationSuggestionQuery, useGetPartnerProfileQuery } = searchPartnersApi
export const { useValidateStepQuery } = validateStepApi
